import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin, TreeSelect } from "antd";
import React, { useEffect, useState } from "react";
import { GetOrganizationLevelsApi } from "../../../api/org-levels/GetOrganizationLevelsApi";
import { GetTreeSelectUnitsApi } from "../../../api/GetTreeSelectUnitsApi";

const { Option } = Select;

function OrganizationFilterModal(props) {
  const [submit, setSubmit] = useState(false);
  const [unitsTree, setUnitsTree] = useState([]);
  const [unit, setUnit] = useState();
  const [orgLevels, setOrgLevels] = useState([]);
  const [form] = Form.useForm();

  function handleCancel() {
    setSubmit(false);
    setOrgLevels([]);
    setUnit();
    props.handleCancel();
    form.resetFields();
  }

  useEffect(() => {
    if (props.visible) {
      getOrganizationLevels();
      getUnitsTree();
    }
  }, [props.visible]);

  async function getOrganizationLevels() {
    const apiResponse = await GetOrganizationLevelsApi();
    if (apiResponse.message === "success") {
      setOrgLevels(apiResponse.levels);
      props.filterBy?.organizationLevel &&
        form.setFields([
          {
            name: "organizationLevel",
            value: props.filterBy?.organizationLevel,
          },
        ]);
    }
  }

  async function getUnitsTree() {
    const apiResponse = await GetTreeSelectUnitsApi();
    if (apiResponse.message === "success") {
      setUnitsTree(apiResponse.units);
    }
    props.filterBy?.unitName &&
      form.setFields([
        {
          name: "unitName",
          value: props.filterBy?.unitName,
        },
      ]);
  }

  function onFinish(values) {
    setSubmit(true);
    if (unit) {
      values.unitName = unit;
    }
    props.handleOk(values);
    handleCancel();
  }

  function selectUnit(value, title) {
    setUnit(title[0]);
  }

  return (
    <Modal
      title="Filter Organization"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="organizationFilter"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Org level" name="organizationLevel">
          <Select placeholder="Select org level">
            {orgLevels.map((level) => {
              return (
                <Option key={level.id} value={level.id}>
                  {level.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item label="Unit name" name="unitName">
          <TreeSelect
            showSearch
            treeLine={true}
            dropdownStyle={{
              maxHeight: 400,
              overflow: "auto",
            }}
            treeData={unitsTree}
            placeholder="Select unit"
            treeDefaultExpandAll
            treeNodeFilterProp={"title"}
            showIcon={false}
            filterTreeNode
            onChange={(value, title) => selectUnit(value, title)}
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="w-28"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Filter"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default OrganizationFilterModal;
